import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { ColumnsBlockProps } from "./ColumnsBlock.types";
import { ColumnsBlockContent } from "@/modules/hub/features/ResourceLibrary/components/ResourceDetailsContentBlock/ResourceDetailsContentBlock";

export function ColumnsBlock({ content }: ColumnsBlockProps) {
  let columnsData: ColumnsBlockContent | null = null;

  try {
    columnsData = JSON.parse(content) as ColumnsBlockContent;
  } catch (e) {
    console.error("Failed to parse columns content:", e);
    return (
      <div className="my-6 p-4 border border-destructive/50 rounded-lg">
        <p className="text-destructive">
          Error: Invalid columns content format
        </p>
      </div>
    );
  }

  // Check if we have any content
  if (!columnsData.leftColumn && !columnsData.rightColumn) {
    return (
      <div className="my-6 p-4 border border-warning/50 rounded-lg">
        <p className="text-warning">Warning: Columns block has no content</p>
      </div>
    );
  }

  return (
    <div className="my-6">
      <div className="bg-gray-50 dark:bg-gray-800/50 rounded-lg p-6 border border-gray-200 dark:border-gray-700">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
          <div className="prose dark:prose-invert max-w-none">
            {columnsData.leftColumn ? (
              <ReactMarkdown
                components={{
                  // All links in resource content open in new tab
                  a: ({ node, children, href, ...props }) => (
                    <a
                      href={href}
                      rel="noopener noreferrer"
                      target="_blank"
                      {...props}
                    >
                      {children}
                    </a>
                  ),
                }}
                remarkPlugins={[remarkGfm]}
              >
                {columnsData.leftColumn}
              </ReactMarkdown>
            ) : (
              <p className="text-gray-400 italic">No content in left column</p>
            )}
          </div>
          <div className="relative prose dark:prose-invert max-w-none">
            <div className="absolute -left-4 top-0 bottom-0 w-px bg-gray-300 dark:bg-gray-600 hidden lg:block" />
            {columnsData.rightColumn ? (
              <ReactMarkdown
                components={{
                  // All links in resource content open in new tab
                  a: ({ node, children, href, ...props }) => (
                    <a
                      href={href}
                      rel="noopener noreferrer"
                      target="_blank"
                      {...props}
                    >
                      {children}
                    </a>
                  ),
                }}
                remarkPlugins={[remarkGfm]}
              >
                {columnsData.rightColumn}
              </ReactMarkdown>
            ) : (
              <p className="text-gray-400 italic">No content in right column</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
